import type { ShareSurface } from '@/lib/share/events';
import copy from '../copy';
import { buildBreadcrumbJsonLd } from './breadcrumb';
import { buildStaticPageJsonLd } from './static-page';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildCompetitionJsonLd(
  surface: Extract<ShareSurface, { kind: 'competition' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const page = buildStaticPageJsonLd({ kind: 'static_page', slug: 'competitions' }, ctx);
  const breadcrumb = buildBreadcrumbJsonLd([
    { name: copy.site.shortName, path: '/' },
    { name: copy.competitionsListing.breadcrumbLabel, path: '/social/competitions' },
    { name: surface.title, path: null },
  ]);
  return [page, breadcrumb].flat().filter((node) => node !== null);
}
